// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full viewport shell — same sky gradient as profile page */
.landing-page {
  min-height: 100dvh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: linear-gradient(210deg, #c5dff7 0%, #eef2f7 52%, #f4f7fa 100%);
  color: #1c2d38;
}

.dashboard-container {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: var(
      --navbar-offset,
      max(
        7.25rem,
        calc(
          max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px + 2.25rem
        )
      )
    )
    clamp(1.25rem, 4vw, 2.5rem) clamp(1.5rem, 4vh, 2.75rem);
  padding-bottom: max(1.75rem, env(safe-area-inset-bottom, 0px));
  font-family: "Segoe UI", system-ui, -apple-system, sans-serif;
  overflow-x: hidden;
}

/* Page intro */
.dashboard-header {
  text-align: center;
  max-width: 42rem;
  margin: 0 auto clamp(1.75rem, 4vw, 2.5rem);
}

.dashboard-eyebrow {
  margin: 0 0 0.5rem;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #2a5570;
  opacity: 0.85;
}

.dashboard-title {
  margin: 0 0 0.65rem;
  font-size: clamp(1.75rem, 4.5vw, 2.25rem);
  font-weight: 700;
  color: #0f2940;
  letter-spacing: -0.03em;
  line-height: 1.15;
}

.dashboard-subtitle {
  margin: 0;
  font-size: clamp(0.9rem, 2vw, 1.05rem);
  font-weight: 400;
  line-height: 1.55;
  color: #3d5666;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 16.5rem), 1fr));
  gap: clamp(1rem, 2.5vw, 1.35rem);
  flex: 1 1 auto;
  align-content: start;
}

@media (min-width: 90rem) {
  .dashboard-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

/* Card shell: tinted surface (accent wash) + top bar */
.dashboard-card {
  --card-accent: #1e5278;
  --card-tint: rgba(30, 82, 120, 0.12);
  position: relative;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(21, 52, 72, 0.11);
  border-radius: 14px;
  border-top: 4px solid var(--card-accent);
  background: linear-gradient(
    168deg,
    color-mix(in srgb, var(--card-accent) 26%, white) 0%,
    color-mix(in srgb, var(--card-accent) 14%, white) 38%,
    color-mix(in srgb, var(--card-accent) 7%, #eef2f6) 72%,
    color-mix(in srgb, var(--card-accent) 4%, #f4f7fa) 100%
  );
  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.04), 0 8px 24px rgba(21, 52, 72, 0.07);
  min-height: 10.5rem;
  min-width: 0;
  text-align: left;
  transition: box-shadow 0.22s ease, border-color 0.22s ease, transform 0.22s ease;
}

@supports (color: color-mix(in srgb, red, white)) {
  .dashboard-card {
    border: 1px solid color-mix(in srgb, var(--card-accent) 16%, #e2e8f0);
  }
}

@supports not (color: color-mix(in srgb, red, white)) {
  .dashboard-card {
    background: linear-gradient(
      168deg,
      var(--card-tint) 0%,
      rgba(255, 255, 255, 0.88) 48%,
      #f4f7fa 100%
    );
  }
}

.dashboard-card:hover {
  box-shadow: 0 4px 8px rgba(21, 52, 72, 0.06), 0 16px 40px rgba(21, 52, 72, 0.1);
  border-color: rgba(21, 52, 72, 0.12);
}

@media (prefers-reduced-motion: no-preference) {
  .dashboard-card:hover {
    transform: translateY(-3px);
  }
}

.dashboard-card-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: clamp(1rem, 2.5vw, 1.25rem) clamp(1rem, 2.5vw, 1.2rem) clamp(1rem, 2.5vw, 1.15rem);
  box-sizing: border-box;
}

.stat-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  margin-bottom: 0.75rem;
  border-radius: 10px;
  background: color-mix(in srgb, var(--card-accent) 28%, white);
  color: var(--card-accent);
  font-size: 1.15rem;
  flex-shrink: 0;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45);
}

@supports not (color: color-mix(in srgb, red, white)) {
  .stat-icon-wrap {
    background: var(--card-tint);
    box-shadow: none;
  }
}

.stat-value {
  margin: 0 0 0.5rem;
  font-size: clamp(1.35rem, 3.5vw, 1.65rem);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  line-height: 1.15;
  color: #0f2940;
  word-break: break-word;
}

.stat-label {
  margin: 0;
  margin-top: auto;
  padding-top: 0.35rem;
  font-size: clamp(0.78rem, 1.8vw, 0.875rem);
  font-weight: 600;
  line-height: 1.4;
  color: #3d5666;
  letter-spacing: 0.01em;
}

.well-id-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  align-self: flex-start;
  margin-top: 0.65rem;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #1e5278;
  background: rgba(30, 82, 120, 0.08);
  border: 1px solid rgba(30, 82, 120, 0.12);
}

.well-id-chip-icon {
  flex-shrink: 0;
  opacity: 0.85;
  font-size: 0.7rem;
}

.well-id-chip-text {
  font-variant-numeric: tabular-nums;
}

/* Accent palette — stronger --card-tint for non-color-mix browsers */
.blue-1 {
  --card-accent: #059669;
  --card-tint: rgba(5, 150, 105, 0.2);
}
.blue-2 {
  --card-accent: #16a34a;
  --card-tint: rgba(22, 163, 74, 0.2);
}
.blue-3 {
  --card-accent: #22c55e;
  --card-tint: rgba(34, 197, 94, 0.2);
}
.blue-4 {
  --card-accent: #0d9488;
  --card-tint: rgba(13, 148, 136, 0.2);
}
.blue-5 {
  --card-accent: #0891b2;
  --card-tint: rgba(8, 145, 178, 0.2);
}
.blue-6 {
  --card-accent: #0284c7;
  --card-tint: rgba(2, 132, 199, 0.2);
}
.blue-7 {
  --card-accent: #d97706;
  --card-tint: rgba(217, 119, 6, 0.22);
}
.blue-8 {
  --card-accent: #ca8a04;
  --card-tint: rgba(202, 138, 4, 0.22);
}
.blue-9 {
  --card-accent: #b45309;
  --card-tint: rgba(180, 83, 9, 0.22);
}
.blue-10 {
  --card-accent: #c2410c;
  --card-tint: rgba(194, 65, 12, 0.22);
}

.map-button-container {
  display: flex;
  justify-content: center;
  margin-top: 3rem;
}

.map-button {
  width: 100%;
  max-width: 24rem;
  padding: 1rem 2rem;
  font-size: clamp(1rem, 2.5vw, 1.25rem);
  font-weight: 600;
  background-color: #3a5c6e;
  color: #f4f7fa;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease;
  box-shadow: 0 4px 14px rgba(21, 52, 72, 0.15);
}

.map-button:hover {
  background-color: #2f4d5e;
}
`, "",{"version":3,"sources":["webpack://./src/landingpage.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB;;;;;;;;;2DASyD;EACzD,8DAA8D;EAC9D,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yEAAyE;EACzE,gCAAgC;EAChC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,uDAAuD;AACvD;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,mBAAmB;EACnB,wCAAwC;EACxC;;;;;;GAMC;EACD,+EAA+E;EAC/E,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE;IACE,qEAAqE;EACvE;AACF;;AAEA;EACE;IACE;;;;;KAKC;EACH;AACF;;AAEA;EACE,+EAA+E;EAC/E,oCAAoC;AACtC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2FAA2F;EAC3F,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,qEAAqE;AACrE;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sDAAsD;EACtD,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Full viewport shell — same sky gradient as profile page */\n.landing-page {\n  min-height: 100dvh;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  background: linear-gradient(210deg, #c5dff7 0%, #eef2f7 52%, #f4f7fa 100%);\n  color: #1c2d38;\n}\n\n.dashboard-container {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  padding: var(\n      --navbar-offset,\n      max(\n        7.25rem,\n        calc(\n          max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px + 2.25rem\n        )\n      )\n    )\n    clamp(1.25rem, 4vw, 2.5rem) clamp(1.5rem, 4vh, 2.75rem);\n  padding-bottom: max(1.75rem, env(safe-area-inset-bottom, 0px));\n  font-family: \"Segoe UI\", system-ui, -apple-system, sans-serif;\n  overflow-x: hidden;\n}\n\n/* Page intro */\n.dashboard-header {\n  text-align: center;\n  max-width: 42rem;\n  margin: 0 auto clamp(1.75rem, 4vw, 2.5rem);\n}\n\n.dashboard-eyebrow {\n  margin: 0 0 0.5rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #2a5570;\n  opacity: 0.85;\n}\n\n.dashboard-title {\n  margin: 0 0 0.65rem;\n  font-size: clamp(1.75rem, 4.5vw, 2.25rem);\n  font-weight: 700;\n  color: #0f2940;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n}\n\n.dashboard-subtitle {\n  margin: 0;\n  font-size: clamp(0.9rem, 2vw, 1.05rem);\n  font-weight: 400;\n  line-height: 1.55;\n  color: #3d5666;\n}\n\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 16.5rem), 1fr));\n  gap: clamp(1rem, 2.5vw, 1.35rem);\n  flex: 1 1 auto;\n  align-content: start;\n}\n\n@media (min-width: 90rem) {\n  .dashboard-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n/* Card shell: tinted surface (accent wash) + top bar */\n.dashboard-card {\n  --card-accent: #1e5278;\n  --card-tint: rgba(30, 82, 120, 0.12);\n  position: relative;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(21, 52, 72, 0.11);\n  border-radius: 14px;\n  border-top: 4px solid var(--card-accent);\n  background: linear-gradient(\n    168deg,\n    color-mix(in srgb, var(--card-accent) 26%, white) 0%,\n    color-mix(in srgb, var(--card-accent) 14%, white) 38%,\n    color-mix(in srgb, var(--card-accent) 7%, #eef2f6) 72%,\n    color-mix(in srgb, var(--card-accent) 4%, #f4f7fa) 100%\n  );\n  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.04), 0 8px 24px rgba(21, 52, 72, 0.07);\n  min-height: 10.5rem;\n  min-width: 0;\n  text-align: left;\n  transition: box-shadow 0.22s ease, border-color 0.22s ease, transform 0.22s ease;\n}\n\n@supports (color: color-mix(in srgb, red, white)) {\n  .dashboard-card {\n    border: 1px solid color-mix(in srgb, var(--card-accent) 16%, #e2e8f0);\n  }\n}\n\n@supports not (color: color-mix(in srgb, red, white)) {\n  .dashboard-card {\n    background: linear-gradient(\n      168deg,\n      var(--card-tint) 0%,\n      rgba(255, 255, 255, 0.88) 48%,\n      #f4f7fa 100%\n    );\n  }\n}\n\n.dashboard-card:hover {\n  box-shadow: 0 4px 8px rgba(21, 52, 72, 0.06), 0 16px 40px rgba(21, 52, 72, 0.1);\n  border-color: rgba(21, 52, 72, 0.12);\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .dashboard-card:hover {\n    transform: translateY(-3px);\n  }\n}\n\n.dashboard-card-inner {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: clamp(1rem, 2.5vw, 1.25rem) clamp(1rem, 2.5vw, 1.2rem) clamp(1rem, 2.5vw, 1.15rem);\n  box-sizing: border-box;\n}\n\n.stat-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  margin-bottom: 0.75rem;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--card-accent) 28%, white);\n  color: var(--card-accent);\n  font-size: 1.15rem;\n  flex-shrink: 0;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45);\n}\n\n@supports not (color: color-mix(in srgb, red, white)) {\n  .stat-icon-wrap {\n    background: var(--card-tint);\n    box-shadow: none;\n  }\n}\n\n.stat-value {\n  margin: 0 0 0.5rem;\n  font-size: clamp(1.35rem, 3.5vw, 1.65rem);\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  color: #0f2940;\n  word-break: break-word;\n}\n\n.stat-label {\n  margin: 0;\n  margin-top: auto;\n  padding-top: 0.35rem;\n  font-size: clamp(0.78rem, 1.8vw, 0.875rem);\n  font-weight: 600;\n  line-height: 1.4;\n  color: #3d5666;\n  letter-spacing: 0.01em;\n}\n\n.well-id-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  align-self: flex-start;\n  margin-top: 0.65rem;\n  padding: 0.35rem 0.65rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #1e5278;\n  background: rgba(30, 82, 120, 0.08);\n  border: 1px solid rgba(30, 82, 120, 0.12);\n}\n\n.well-id-chip-icon {\n  flex-shrink: 0;\n  opacity: 0.85;\n  font-size: 0.7rem;\n}\n\n.well-id-chip-text {\n  font-variant-numeric: tabular-nums;\n}\n\n/* Accent palette — stronger --card-tint for non-color-mix browsers */\n.blue-1 {\n  --card-accent: #059669;\n  --card-tint: rgba(5, 150, 105, 0.2);\n}\n.blue-2 {\n  --card-accent: #16a34a;\n  --card-tint: rgba(22, 163, 74, 0.2);\n}\n.blue-3 {\n  --card-accent: #22c55e;\n  --card-tint: rgba(34, 197, 94, 0.2);\n}\n.blue-4 {\n  --card-accent: #0d9488;\n  --card-tint: rgba(13, 148, 136, 0.2);\n}\n.blue-5 {\n  --card-accent: #0891b2;\n  --card-tint: rgba(8, 145, 178, 0.2);\n}\n.blue-6 {\n  --card-accent: #0284c7;\n  --card-tint: rgba(2, 132, 199, 0.2);\n}\n.blue-7 {\n  --card-accent: #d97706;\n  --card-tint: rgba(217, 119, 6, 0.22);\n}\n.blue-8 {\n  --card-accent: #ca8a04;\n  --card-tint: rgba(202, 138, 4, 0.22);\n}\n.blue-9 {\n  --card-accent: #b45309;\n  --card-tint: rgba(180, 83, 9, 0.22);\n}\n.blue-10 {\n  --card-accent: #c2410c;\n  --card-tint: rgba(194, 65, 12, 0.22);\n}\n\n.map-button-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 3rem;\n}\n\n.map-button {\n  width: 100%;\n  max-width: 24rem;\n  padding: 1rem 2rem;\n  font-size: clamp(1rem, 2.5vw, 1.25rem);\n  font-weight: 600;\n  background-color: #3a5c6e;\n  color: #f4f7fa;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.15s ease;\n  box-shadow: 0 4px 14px rgba(21, 52, 72, 0.15);\n}\n\n.map-button:hover {\n  background-color: #2f4d5e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
